export default __webpack_public_path__ + "static/media/success.59577034.svg";